import { Button, Input, InputNumber, message, Modal, PageHeader, Select, Tree } from 'antd';
import React, { useEffect, useState } from 'react';
import { useUpdateEffect } from 'ahooks';
import { ontologyProperties, ontologyPropertyAdd, ontologyPropertyDel, ontologyPropertyEdit } from '../../../../api/inspiration';
import './index.less';
const { Search } = Input;
const { Option } = Select;
export default () => {
    const [expandedKeys, setExpandedKeys] = useState();
    const [checkedKeys, setCheckedKeys] = useState();
    const [selectedKeys, setSelectedKeys] = useState([]);
    const [autoExpandParent, setAutoExpandParent] = useState(true);
    const [treeData, setTreeData] = useState([])
    const [filterTreeData, setFilterTreeData] = useState(treeData)
    const [currentClassify, setCurrentClassify] = useState()
    const [parentClassify, setParentClassify] = useState()
    const [addParam, setAddParam] = useState({
        parentName: "", name: '', translateWord: '', level: 0, noShowAttr: 0
    });

    const initTreeData = () => {
        ontologyProperties().then(res => {
            if (res.error.code == 0) {

                let count = 0
                let temp = []


                res.data.forEach((e1, index1) => {
                    let obj1 = {
                        ...e1,
                        title: e1.node_word,
                        key: `${index1}`,
                    }
                    count++

                    if (e1.child) {
                        let childList = []
                        e1.child.forEach((e2, index2) => {
                            let obj2 = {
                                ...e2,
                                title: e2.node_word,
                                key: `${index1}-${index2}`
                            }
                            count++
                            if (e2.child) {
                                let childList2 = []
                                e2.child.forEach((e3, index3) => {
                                    let obj3 = {
                                        ...e3,
                                        title: e3.node_word,
                                        key: `${index1}-${index2}-${index3}`
                                    }
                                    count++
                                    if (e3.child) {
                                        let childList4 = []
                                        e3.child.forEach((e4, index4) => {
                                            let obj4 = {
                                                ...e4,
                                                title: e4.node_word,
                                                key: `${index1}-${index2}-${index3}-${index4}`
                                            }
                                            count++
                                            childList4.push(obj4)
                                        })
                                        obj3.children = childList4
                                    }

                                    childList2.push(obj3)
                                })
                                obj2.children = childList2
                            }
                            childList.push(obj2)
                        })
                        obj1.children = childList
                    }
                    temp.push(obj1)
                });
                setTreeData(temp)
                setFilterTreeData(temp)
            }
        }).catch(e => {
            console.log(e);
        })
    }

    useEffect(() => {
        initTreeData()
    }, [])

    const onExpand = (expandedKeysValue) => {
        console.log('onExpand', expandedKeysValue); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.

        setExpandedKeys(expandedKeysValue);
        setAutoExpandParent(false);
    };

    const onCheck = (checkedKeysValue) => {
        console.log('onCheck', checkedKeysValue);
        setCheckedKeys(checkedKeysValue);
    };

    const onSelect = (selectedKeysValue, info) => {
        console.log('onSelect', selectedKeysValue, info);
        setSelectedKeys(selectedKeysValue);
    };

    const onSearch = (value) => {
        if (!value) {
            return setFilterTreeData(treeData)
        }
        let temp = _.cloneDeep(treeData)
        temp.map(item => {
            if (item.children) {
                item.children.map(item2th => {
                    if (item2th.children) {
                        item2th.children = item2th.children.map(item3th => {
                            if (item3th.children) {
                                item3th.children = item3th.children.filter(item4th => {
                                    return item4th.title.indexOf(value) > -1 || item3th.title.indexOf(value) > -1 || item2th.title.indexOf(value) > -1 || item.title.indexOf(value) > -1
                                })
                            }
                            return item3th
                        })
                        item2th.children = item2th.children.filter(item3th => {
                            return item3th.title.indexOf(value) > -1 || item2th.title.indexOf(value) > -1 || item.title.indexOf(value) > -1  || item3th.children?.length > 0
                        })
                    }
                    return item2th
                })
                item.children = item.children.filter(item2th => {
                    return item2th.title.indexOf(value) > -1 || item.title.indexOf(value) > -1 || item2th.children?.length > 0
                })
            }
            return item
        })
        temp = temp.filter(item => {
            return item.title.indexOf(value) > -1 || item.children?.length > 0
        })
        setFilterTreeData(temp)
    }

    const [modalVisible, setModalVisible] = useState({ visible: false, type: null }) // 弹窗类型， 0-删除 1-新增 2-修改 3-查看详情

    useUpdateEffect(() => {
        if (modalVisible.visible) {
            initSelectedClassify()
        } else {
            setAddParam({ parentName: "", name: '', translateWord: '', level: 0, noShowAttr: 0 })
            setCurrentClassify(null)
            setParentClassify(null)
        }
    }, [modalVisible])

    const handleDelModalOk = async () => {
        if (modalVisible.type == 0) {
            const confirmStatus = window.confirm('高危操作，若仍要删除，点击确定,需要再处理，点击取消')
            if (confirmStatus) {
                const res = await ontologyPropertyDel({ id: currentClassify.id, name: currentClassify.title, force: true, parentId: parentClassify?.id })
                if (res.error.code == 0) {
                    message.success('删除成功')
                    initTreeData()
                } else {
                    message.error(res.error.message)
                }
                setModalVisible({ visible: false })
            }
        } else if (modalVisible.type == 2) {
            const params = {
                id: currentClassify.id,
                name: currentClassify.title,
                parentId: parentClassify?.id,
                parentName: parentClassify?.title,
                translation_word: currentClassify.translation_word,
                level: currentClassify.node_level,
                noShowAttr: currentClassify.no_show_attr
            }
            ontologyPropertyEdit(params).then(res => {
                if (res.error.code == 0) {
                    message.success('编辑成功')
                } else {
                    message.error('编辑失败:' + res.error.message)
                }
            }).finally(() => {
                initTreeData()
                setModalVisible({ visible: false })
            })
        }

    }

    const handleSubmit = () => {
        if (addParam.name.trim() == '') {
            return message.warn('名称不能为空')
        }
        ontologyPropertyAdd(addParam).then(res => {
            if (res.error.code == 0) {
                message.success('提交成功')
                initTreeData()
            } else {
                message.error(res.error.message)
            }
        }).finally(() => {
            setAddParam({ parentName: "", name: '', translateWord: '', level: 1, noShowAttr: 0 })
            setModalVisible({ visible: false })
        })
    };

    const initSelectedClassify = () => {
        if (!selectedKeys[0]) {
            return
        }

        const indexs = selectedKeys[0].split('-')
        switch (indexs.length) {
            case 1:
                setCurrentClassify(treeData[indexs[0]])
                break;
            case 2:
                setParentClassify(treeData[indexs[0]])
                setCurrentClassify(treeData[indexs[0]].children[indexs[1]])
                break;
            case 3:
                setParentClassify(treeData[indexs[0]].children[indexs[1]])
                setCurrentClassify(treeData[indexs[0]].children[indexs[1]].children[indexs[2]])
                break;
            case 4:
                setParentClassify(treeData[indexs[0]].children[indexs[1]].children[indexs[2]])
                setCurrentClassify(treeData[indexs[0]].children[indexs[1]].children[indexs[2]].children[indexs[3]])
                break;
            default:
                break;
        }
    }

    useEffect(() => {
        initSelectedClassify()
    }, [selectedKeys])

    

    const renderModal = () => {
        if (modalVisible.visible) {
            if (modalVisible.type == 1) {
                return <Modal title="新增属性" visible={true} footer={null} onCancel={() => setModalVisible({ visible: false })}>
                    <div>
                        <label>上级属性名称*：</label>
                        <Input placeholder="上级属性名称,为空则为顶级属性" value={addParam.parentName} onChange={(e) => {
                            setAddParam({
                                ...addParam,
                                parentName: e.target.value
                            })
                        }} />
                    </div>
                    <div>
                        <label>属性名称：</label>
                        <Input placeholder="属性名称" value={addParam.name} onChange={(e) => {
                            setAddParam({
                                ...addParam,
                                name: e.target.value
                            })
                        }} />
                    </div>
                    <div>
                        <label>翻译词：</label>
                        <Input placeholder="翻译词" value={addParam.translateWord} onChange={(e) => {
                            setAddParam({
                                ...addParam,
                                translateWord: e.target.value
                            })
                        }} />
                    </div>
                    {/* <div>
                        <label>节点等级：&nbsp;&nbsp;</label>
                        <InputNumber placeholder='节点等级' min={0} max={10} value={addParam.level} onChange={(value) => setAddParam({ ...addParam, level: value })} />
                    </div> */}
                    <div>
                        <label>是否为属性项：</label>
                        <Select style={{ width: 120 }} defaultValue={"1"} value={addParam.noShowAttr} onChange={(value) =>
                            setAddParam({ ...addParam, noShowAttr: value })}>
                            <Option value={0}>否</Option>
                            <Option value={1}>是</Option>
                        </Select>
                    </div>
                    <div>
                        <Button type="primary" onClick={() => handleSubmit()}>
                            提交
                        </Button>
                    </div>

                </Modal>
            }

            if (selectedKeys.length == 0) {
                // 如果没有选中，则不展示弹窗
                setModalVisible({ visible: false })
                return <></>
            }
            switch (modalVisible.type) {
                case 0:
                    return <Modal title="删除" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <p>您要删除的属性是：{currentClassify?.title}</p>
                    </Modal>
                case 2:
                    return <Modal title="修改属性" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <div>属性名称：<Input value={currentClassify?.title} onChange={(e) => setCurrentClassify({ ...currentClassify, title: e.target.value })} /></div>
                        <div>上级属性：<Input value={parentClassify?.title} onChange={(e) => setParentClassify({ ...parentClassify, title: e.target.value })} /></div>
                        <div>翻译词：<Input value={currentClassify?.translation_word} onChange={(e) => setCurrentClassify({ ...currentClassify, translation_word: e.target.value })} /></div>
                        {/* <div>节点等级：<InputNumber value={currentClassify.node_level} placeholder='节点等级' min={0} max={10} onChange={(value) => setCurrentClassify({ ...currentClassify, node_level: value })} /></div> */}
                        <div>
                            <label>是否为属性项：</label>
                            <Select style={{ width: 120 }} defaultValue={currentClassify?.no_show_attr} value={currentClassify?.no_show_attr} onChange={(value) =>
                                setCurrentClassify({ ...currentClassify, no_show_attr: value })}>
                                <Option value={0}>否</Option>
                                <Option value={1}>是</Option>
                            </Select>
                        </div>
                    </Modal>
                case 3:

                    return <Modal title="查看详情" visible={true} onOk={handleDelModalOk} okText='确定' cancelText='取消' onCancel={() => setModalVisible({ visible: false })}>
                        <p>属性名称：{currentClassify?.title}</p>
                        <p>上级属性：{parentClassify?.title}</p>
                        <p>翻译词：{currentClassify?.translation_word}</p>
                        {/* <p>节点等级：{currentClassify.node_level}</p> */}
                        <p>是否为属性项：{(currentClassify?.no_show_attr == 0) ? '否' : '是'}</p>
                    </Modal>
                default:
                    break;
            }
        }
        return <></>
    }


    return (
        <div className='ontolyContainer' >
            <PageHeader style={{ position: 'fixed', top: 0, left: 500 }}>
                <Search placeholder="" onSearch={onSearch} style={{ width: 200 }} />
                <Button onClick={() => { window.location.reload() }}>重置</Button>
                <Button onClick={() => setModalVisible({ visible: true, type: 0 })}>删除</Button>
                <Button onClick={() => setModalVisible({ visible: true, type: 1 })}>新增</Button>
                <Button onClick={() => setModalVisible({ visible: true, type: 2 })}>修改</Button>
                <Button onClick={() => setModalVisible({ visible: true, type: 3 })}>查看详情</Button>
            </PageHeader>
            <Tree
                multiple={false}
                checkStrictly={true}
                onExpand={onExpand}
                expandedKeys={expandedKeys}
                autoExpandParent={autoExpandParent}
                onCheck={onCheck}
                checkedKeys={checkedKeys}
                onSelect={onSelect}
                selectedKeys={selectedKeys}
                treeData={filterTreeData}
            />
            {renderModal()
            }
        </div >
    );
};